import { CSSObject, Theme } from '@mui/material'

import { CommonStatus } from './types'

export const selectColor = <T extends CommonStatus>(
  status: T,
  theme: Theme,
): CSSObject['backgroundColor'] => {
  switch (status) {
    case 'completed':
    case 'created':
      return theme.palette.success.main
    case 'failed':
    case 'notCreated':
    case 'superseded':
      return theme.palette.grey[500]
    case 'inProgress':
    case 'queued':
    case 'started':
      return theme.palette.warning.main

    default: {
      throw new Error(`Unhandled status: ${status}`)
    }
  }
}
